import AppTools from 'utils/app/appTools'
import Config from 'utils/config'


const getBenchmark = () => {
  const lang = AppTools.getActualLanguage()
  return Config.getConfig().app.urls.BASE_URL_HONTZA + `geo/tagged/eccp-2020-eu27_2020?lang=${lang}`
}

const getBenchmarkCountries = () => {
  const lang = AppTools.getActualLanguage()
  return Config.getConfig().app.urls.BASE_URL_HONTZA + `geo/tagged/benchmark2018-country?lang=${lang}`
}

const getAllIndicators = () => {
  const lang = AppTools.getActualLanguage()
  return Config.getConfig().app.urls.BASE_URL_HONTZA + `indicator?lang=${lang}`
}

const getIndicator = indicator => {
  const lang = AppTools.getActualLanguage()
  return Config.getConfig().app.urls.BASE_URL_HONTZA + `indicator/${indicator}?lang=${lang}`
}

const getIndicatorsStatus = () => {
  const indicator_tag = Config.getConfig().indicator_tag;
  return Config.getConfig().app.urls.BASE_URL_HONTZA + `indicator/tagged/${indicator_tag}/status`;
}

const getReferenceRegions = ({ selectedRegionCode }) => {
  const lang = AppTools.getActualLanguage()
  return Config.getConfig().app.urls.BASE_URL_S3PLATFORM + `rev/2018/dist/${selectedRegionCode}/30/0?lang=${lang}`
}

const getNewestDataForIndicatorAndRegions = ({ indicator, query }) => {
  return Config.getConfig().app.urls.BASE_URL_HONTZA + `indicator/${indicator}/query?${query}&time=newest&ignore_missing=yes`
}

const getEvolutionForIndicatorAndRegions = ({ indicator, query }) => {
  return Config.getConfig().app.urls.BASE_URL_HONTZA + `indicator/${indicator}/query?${query}`
}

const getDataInSpecificYearForIndicatorAndRegions = ({ indicator, query, year }) => {
  return Config.getConfig().app.urls.BASE_URL_HONTZA + `indicator/${indicator}/query?${query}&time=${year}&ignore_weight=yes&ignore_missing=yes`
}

const getEvolutionForRegionAndIndicator = ({ indicator, selectedRegionId }) => {
  return Config.getConfig().app.urls.BASE_URL_REGPANEL + `geo/${selectedRegionId}/${indicator}`
}

const getRelatedDocumentsLevel = ({ selectedRegionCode, level }) => {
  const lang = AppTools.getActualLanguage()
  const regionCode = selectedRegionCode.toLowerCase()
  let levelQuery
  switch (level) {
  case 1:
    levelQuery = 'framework-result'
    break
  case 2:
    levelQuery = 'framework-performance'
    break
  case 3:
    levelQuery = 'framework-determinant'
    break
  default:
    return Config.getConfig().app.urls.BASE_URL_HONTZA + `resource/search?key=${regionCode}&lang=${lang}`
  }
  return Config.getConfig().app.urls.BASE_URL_HONTZA + `resource/search?key=${regionCode},${levelQuery}&lang=${lang}`
}

const getRelatedDocumentsIndicator = ({ selectedRegionCode, indicator }) => {
  const lang = AppTools.getActualLanguage()
  const regionCode = selectedRegionCode.toLowerCase()
  return Config.getConfig().app.urls.BASE_URL_HONTZA + `resource/search?key=${regionCode},indicator-${indicator}&lang=${lang}`
}

const APIURL = {
  getBenchmark,
  getBenchmarkCountries,
  getAllIndicators,
  getIndicator,
  getIndicatorsStatus,
  getReferenceRegions,
  getNewestDataForIndicatorAndRegions,
  getEvolutionForIndicatorAndRegions,
  getDataInSpecificYearForIndicatorAndRegions,
  getEvolutionForRegionAndIndicator,
  getRelatedDocumentsLevel,
  getRelatedDocumentsIndicator
}

export default APIURL



// WEBPACK FOOTER //
// ./src/utils/api/urls.js